<template>
    <div class="desktop-main">
        <div class="logo">
            <img src="@/assets/logo-large.png"/>
        </div>
        <Btn v-if="client.redirect_uri" class="back-to-site" primary @click="back">Вернуться на сайт</Btn>
        <div class="form-container">
            <h1>{{ $route.meta.title }}</h1>
            <div class="tab-buttons">
                <router-link class="tab-btn" :to="{ name: 'login' }">Вход</router-link>
                <router-link class="tab-btn" :to="{ name: 'register' }">Регистрация</router-link>
            </div>
            <router-view @hideAll="hideAll"></router-view>
        </div>

    </div>
</template>
<script>

import { mapGetters } from 'vuex';

const getters = ['client'];

export default {
    name: "DesktopMain",
    computed: {
        ...mapGetters(getters),
    },
    methods: {
        back(){
            window.location.href = this.client.redirect_uri;
        },
        hideAll(){
            this.$emit('hideAll');
        },
    },
};
</script>

<style lang="scss" scoped>
    .logo{
        position: absolute;
        top: 20px;
        left: 20px;
        img{
            width: 170px;
        }
    }

    .form-container{
        position: absolute;
        left: 50%;
        top: 55%;
        background-color: #fff;
        transform: translateX(-50%) translateY(-50%);
        -webkit-box-shadow: 2px 4px 16px rgba(80,97,111,0.23626), 0px 3px 22px rgba(0,0,0,0.354);
        box-shadow: 2px 4px 16px rgba(80,97,111,0.23626), 0px 3px 22px rgba(0,0,0,0.354);
        border-radius: 8px;
        width: 560px;
        min-height: 640px;
        padding: 32px 72px;
        box-sizing: border-box;
        font-family: "Montserrat", sans-serif;

        h1{
            text-align: center;
            font-family: "Futura PT", sans-serif;
            font-size: 35px;
            line-height: 51px;
            text-align: center;
            color: #2A2626;
        }
    }

    .back-to-site {
        position: absolute;
        top: 7rem;
        left: 50%;
        transform: translateX(-50%);
    }

    .tab-buttons{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        height: 50px;
        margin-bottom: 32px;
    }
    .tab-btn{
        flex-basis: 196px;
        text-align: center;
        border-bottom: 2px solid #BAC5CB;
        box-sizing: border-box;
        padding: 12px 0 4px;
        height: 100%;
        text-decoration: none;

        font-family: "Futura PT", sans-serif;
        font-size: 24px;
        line-height: 31px;
        color: #BAC5CB;

        &.router-link-active {
            border-bottom-color: #3CA2DF;
            color: #000;
        }
    }
</style>